import { observable }  from 'mobx';
import { action }      from 'mobx';
import { ModalProps }  from '@widesk-ui/components/modal/Modal';
import _uniqueId       from 'lodash/uniqueId';
import { HookAPI }     from 'antd/lib/modal/useModal';
import devToolbarStore from '@widesk-core/stores/devToolbarStore';

// On sépare modal et modalProps pour éviter que les props soient wrapped dans le proxy mobx
const modals = observable<string>([]);
const modalsProps: ModalProps[] = [];

let modalCtx: HookAPI | undefined = undefined;

const store = {
	modals,
	modalsProps,
	addModal: action((modalProps: ModalProps) => {
		devToolbarStore.clearRequests();
		modals.push(_uniqueId());
		modalsProps.push({ open: true, ...modalProps });
	}),
	addModalAsync: async function (modalProps: ModalProps) {
		return new Promise(resolve => {
			store.addModal({
				...modalProps,
				onClose: () => {
					modalProps.onClose?.();
					setTimeout(() => resolve(true));
				},
			});
		});
	},
	removeLastModal: action(() => {
		modals.pop();
		modalsProps.pop();
	}),
	clear: action(() => {
		modals.clear();
		modalsProps.length = 0;
	}),
	setModalCtx: (modal: HookAPI) => modalCtx = modal,
	useModal: () => modalCtx,
};

export default store;
